export const paymongo_key = process.env.REACT_APP_PAYMONGO_SK;
export const url_path = process.env.REACT_APP_URL_PATH;
export const captchakey = process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY;
